import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useAppDispatch, useAppSelector } from "../../store";
import clienteApi from "../../api/cliente.api";
import planoApi from "../../api/plano.api";
import InputCadastro from "./componentes/inputCadastro";
import InputCpf from "./componentes/inputCpf";
import InputPasswordAuth from "./componentes/inputPasswordLogin";
import logo from "../../assets/logohorizontal.png";
import Mockup from "../../assets/mockup.jpg";
import Footer from "../../components/Footer";
import { toCurrency } from "../../helpers/toCurrency";
import enqueueSnackbar from "../../helpers/enqueueSnackbar";
import formatPlanoNome from "../../helpers/formatPlanoNome";
import {
  DEFAULT_PLANO_ID,
  PROPOSTA_PLANO_ID_KEY,
  PROPOSTA_VENDEDOR_ID_KEY,
} from "../../helpers/constants";

type FormState = "cpf" | "password" | "register";

function ValidacaoCadastroLinkApp() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const { loading, plano } = useAppSelector((state) => state.planos);

  const [planoId, setPlanoId] = useState<number>(null);
  const [cpf, setCpf] = useState<string>("");
  const [formState, setFormState] = useState<FormState>("cpf");

  function setReferralData(): void {
    let planoId: number | null = null;

    const paramPlanoId = searchParams.get(PROPOSTA_PLANO_ID_KEY);
    const paramVendedorId = searchParams.get(PROPOSTA_VENDEDOR_ID_KEY);

    const localStoragePlanoId = localStorage.getItem(PROPOSTA_PLANO_ID_KEY);

    if (paramPlanoId && !isNaN(+paramPlanoId)) {
      planoId = +paramPlanoId;
      localStorage.setItem(PROPOSTA_PLANO_ID_KEY, paramPlanoId);
    } else if (
      !paramPlanoId &&
      localStoragePlanoId &&
      !isNaN(+localStoragePlanoId)
    ) {
      planoId = +localStoragePlanoId;
    } else if (!!DEFAULT_PLANO_ID) {
      planoId = +DEFAULT_PLANO_ID;
    }

    if (paramVendedorId && !isNaN(+paramVendedorId)) {
      localStorage.setItem(PROPOSTA_VENDEDOR_ID_KEY, paramVendedorId);
    }

    if (!!planoId) {
      setPlanoId(planoId);
    }
  }

  async function OnSubmitData() {
    try {
      const clienteExists = await clienteApi.cpfExists(
        cpf.replaceAll(/\D+/g, "")
      );

      setFormState(clienteExists ? "password" : "register");
    } catch {
      enqueueSnackbar(
        "Um erro inesperado aconteceu ao verificar o CPF.",
        "error"
      );
    }
  }

  async function loadPlano(planoId: number, abortController?: AbortController) {
    try {
      dispatch({ type: "SET_LOADING_PLANO", payload: true });

      const plano = await planoApi.findById(planoId, abortController);

      dispatch({ type: "SET_PLANO", payload: plano });
    } catch (error) {
      if (!error?.code || error.code !== "ERR_CANCELED") {
        enqueueSnackbar(
          error?.message ||
            "Não foi possível carregar as infromações do plano a ser contratado.",
          "error"
        );
      }
    } finally {
      dispatch({ type: "SET_LOADING_PLANO", payload: false });
    }
  }

  useEffect(() => {
    setReferralData();
  }, [searchParams]);

  useEffect(() => {
    const abortController = new AbortController();

    if (!!planoId) {
      loadPlano(planoId, abortController);
    }

    return () => {
      abortController.abort();
    };
  }, [planoId]);

  return (
    <div
      style={{
        overflowY: "scroll",
        height: "100%",
      }}
    >
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item sm={6} xs={12}>
          <div
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "80%" }}>
              <img src={logo} alt="Logo Fynd" style={{ marginTop: 70 }} />
              <div style={{ marginTop: 15 }}>
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: 30,
                    margin: 0,
                    marginTop: 20,
                    color: "#191919",
                  }}
                >
                  {loading
                    ? "Carregando plano..."
                    : !!plano
                    ? formatPlanoNome(plano.nome)
                    : "Plano família"}
                </h3>

                {!loading && (
                  <h4
                    style={{
                      fontWeight: "400",
                      fontSize: 16,
                      margin: 0,
                      color: "#191919",
                    }}
                  >
                    Por apenas{" "}
                    <b style={{ color: "#4f8d96" }}>
                      {toCurrency(!!plano ? plano.valor : 69.9)}
                    </b>{" "}
                    ao mês
                  </h4>
                )}
              </div>

              {formState === "cpf" ? (
                <InputCpf
                  cpf={cpf}
                  setCpf={setCpf}
                  OnSubmitData={OnSubmitData}
                />
              ) : formState === "password" ? (
                <InputPasswordAuth cpf={cpf} />
              ) : (
                <InputCadastro cpf={cpf} />
              )}
            </div>
          </div>
        </Grid>
        <Grid item sm={6} xs={12}>
          <div
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={Mockup}
              alt="Mockup"
              style={{ marginTop: 50, width: 250 }}
            />
          </div>
        </Grid>
      </Grid>

      <Footer />
    </div>
  );
}

export default ValidacaoCadastroLinkApp;
